import type { CityConfig } from "@/pages/city-template/types";

export const littletonNhConfig: CityConfig = {
  city: "Littleton",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "littleton-nh",
  route: "/cities/littleton-nh",
  title: "Emergency & Expedited Passport Services Littleton NH | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Littleton, NH — as fast as 24 hours. No Littleton passport agency. Fast Passport Center couriers to the Boston Passport Agency at Tip O'Neill Federal Building, about 170 miles south. A+ BBB rated. Serving Bethlehem, Whitefield, Lisbon, Franconia, and all North Country travelers heading abroad for business, adventure, or family.",
  h1: "Emergency & Expedited Passport Services in Littleton, NH",
  heroSubtitle: "Littleton sits in the heart of New Hampshire's North Country along the Ammonoosuc River in Grafton County — a historic mill town turned vibrant mountain community known for its independent spirit, covered bridges, and the iconic Chutters candy counter. Fast Passport Center's registered couriers deliver your documents to the Boston Passport Agency at the Tip O'Neill Federal Building so you get a new or renewed passport as fast as 24 hours — whether you're a White Mountain outdoor guide heading to an international expedition, a Main Street entrepreneur attending an overseas trade event, or a North Country family planning the trip of a lifetime abroad.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Littleton%20New%20Hampshire%20downtown%20Main%20Street%20with%20historic%20brick%20buildings%20and%20the%20Ammonoosuc%20River%20running%20through%20town%2C%20White%20Mountains%20visible%20in%20background%20during%20vibrant%20autumn%20foliage%20season%2C%20classic%20New%20England%20small%20town%20with%20covered%20bridge%20and%20church%20steeple%2C%20wide%20angle%20landscape%20photography%20with%20rich%20fall%20colors&width=1800&height=700&seq=littleton-nh-hero-001&orientation=landscape",
  heroImageAlt: "Littleton New Hampshire downtown with White Mountains and autumn foliage",
  geoPosition: "44.3062;-71.7717",
  geoPlacename: "Littleton, New Hampshire",
  lastModified: "2026-06-06",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "Tip O'Neill Federal Building, 10 Causeway Street, Boston, MA 02222",
    distance: "Approximately 170 miles from Littleton — about 2 hours 45 minutes via I-93 south",
  },
  nearbyCitiesZips: [
    { name: "Littleton", zips: "03561" },
    { name: "Bethlehem", zips: "03574" },
    { name: "Whitefield", zips: "03598" },
    { name: "Lisbon", zips: "03585" },
    { name: "Franconia", zips: "03580" },
    { name: "Sugar Hill", zips: "03586" },
    { name: "Lancaster", zips: "03584" },
    { name: "Twin Mountain", zips: "03595" },
    { name: "Woodsville", zips: "03785" },
    { name: "St. Johnsbury", zips: "05819" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to Boston Passport Agency — about 170 miles from Littleton via I-93" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "North Country Service", desc: "Serving Littleton, Bethlehem, Whitefield, Franconia, and all northern Grafton County" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Littleton case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in New Hampshire", route: "/states/new-hampshire" },
    { name: "Expedited passport in Manchester NH", route: "/manchester" },
    { name: "Urgent passport in Littleton NH", route: "/cities/littleton-nh" },
    { name: "New Hampshire passport hub", route: "/states/new-hampshire" },
    { name: "Fast passport in Concord NH", route: "/concord-nh" },
    { name: "Expedited passport in Berlin NH", route: "/cities/berlin" },
    { name: "Emergency passport in Lancaster NH", route: "/cities/lancaster-nh" },
  ],
  fpcOfficeAddress: "Tip O'Neill Federal Building, 10 Causeway Street, Boston, MA 02222",
  fpcOfficeNote: "Fast Passport Center serves Littleton remotely via secure courier. Our registered couriers hand-deliver your documents to the Boston Passport Agency at the Tip O'Neill Federal Building — approximately 170 miles south. Littleton's location along I-93 makes Boston courier routing reliable and efficient, even during winter months when the Franconia Notch corridor is maintained as a priority route. Our dedicated agents ensure North Country travelers never need to navigate the 2 hour 45 minute drive to Boston for passport processing.",
  fpcOfficeDistance: "Serving all of Grafton County's North Country and the White Mountains corridor",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Littleton, Bethlehem, Whitefield, Franconia, Lisbon, and the entire North Country corridor. From White Mountain outdoor guides to Main Street business owners, we help Littleton travelers get their passports fast.",
  nearbyCitiesIntro: "We serve Littleton and nearby communities including Bethlehem, Whitefield, Lisbon, Franconia, Sugar Hill, Twin Mountain, and the northern White Mountains region — plus St. Johnsbury, Vermont just across the Connecticut River.",
  howItWorksIntro: "Most Littleton travelers complete everything online and ship documents overnight. At approximately 170 miles from Boston, Fast Passport Center provides fast courier turnaround for North Country residents — eliminating the nearly 3-hour drive through the Franconia Notch and I-93 corridor to Boston.",
  mistakesIntro: "Littleton travelers, including White Mountain outdoor professionals and North Country families, face unique passport challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Littleton and North Country travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Littleton? Here are the most common ones we hear from North Country and White Mountains area travelers.",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (NH Vital Records)", url: "https://www.sos.nh.gov/vital-records", desc: "New Hampshire Secretary of State — Vital Records for birth and death certificates statewide" },
    { label: "Marriage Licenses (Grafton County Clerk)", url: "https://www.graftoncountynh.gov/", desc: "Grafton County Clerk for Littleton and North Country" },
    { label: "Divorce Decrees (Grafton County Superior Court)", url: "https://www.courts.state.nh.us/courts/superior.htm", desc: "Grafton County Superior Court for divorce decree records" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order New Hampshire vital records online via VitalChek" },
  ],
  statePageRoute: "/states/new-hampshire",
  statePageName: "New Hampshire",
  dmvWebsite: "https://www.nh.gov/safety/divisions/dmv/index.htm",
  dmvLabel: "New Hampshire DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins at Causeway Street",
        "Life-or-death emergencies only",
        "170 miles to Boston (2 hours 45 minutes via I-93)",
        "Still requires pre-scheduled NPIC appointment",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "No drive or appointment needed",
        "Ideal for White Mountain guides",
        "Perfect for North Country families",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from BOS or MHT",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Cannot upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Littleton is 170 miles from the Boston Passport Agency — our courier service saves North Country travelers the I-93 drive through Franconia Notch and Boston traffic.",
      bullets: ["Grafton County coverage", "24–48 hour turnaround available", "No appointment or drive needed"],
      badge: "Fastest in the North Country",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Littleton adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Littleton and North Country"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Littleton and Grafton County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Littleton and North Country residents with DS-64 form guidance and courier routing to Boston.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Boston agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Grafton County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Littleton and North Country residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Littleton NH", description: "Urgent passport processing for Littleton, NH travelers via Boston Passport Agency courier — 170 miles from Littleton." },
    { name: "Passport Renewal Littleton NH", description: "Fast passport renewal for Littleton and Grafton County, New Hampshire residents." },
    { name: "New Passport Littleton NH", description: "First-time passport application assistance for Littleton and North Country area residents." },
    { name: "Lost Passport Littleton NH", description: "Passport replacement for lost or stolen passports for Littleton and Grafton County residents." },
    { name: "Child Passport Littleton NH", description: "Minor passport services for Littleton and North Country families." },
    { name: "Name Change Passport Littleton NH", description: "Passport name change service for Littleton, NH residents." },
  ],
  testimonials: [
    {
      name: "Jake R.",
      location: "Littleton, NH — White Mountain Guide",
      rating: 5,
      text: "I lead guided expeditions in the Himalayas and Andes. Booked a Kilimanjaro trip on relatively short notice in January and realized my passport only had 4 months left — Tanzania requires 6. Fast Passport Center renewed it in 6 business days during the dead of winter. They understand North Country timelines and don't let snow storms delay anything.",
      service: "Passport Renewal",
    },
    {
      name: "The M Family",
      location: "Bethlehem, NH",
      rating: 5,
      text: "Family of five planning a trip to Ireland — our kids had never been abroad. Three first-time child passports plus two adult renewals. Fast Passport Center processed all five documents simultaneously in 9 business days. The agent walked us through DS-11 requirements for the kids, coordinated the Bethlehem Post Office appointment, and kept us updated daily. Absolutely flawless.",
      service: "Family Passport Package",
    },
    {
      name: "Margaret C.",
      location: "Franconia, NH",
      rating: 5,
      text: "Retired teacher who has lived in the North Country for 40 years. Planned a retirement celebration trip to Scotland — didn't realize my passport expired 2 years ago. I was terrified I'd miss the trip. Fast Passport Center got me a new passport in 7 business days. The courier came right to my door in Franconia for document pickup.",
      service: "Passport Renewal",
    },
    {
      name: "Tom and Sarah W.",
      location: "Sugar Hill, NH",
      rating: 5,
      text: "We own a B&B in Sugar Hill and had a sudden opportunity to attend an international hospitality conference in Switzerland. Our passports were both within the 6-month window — too close for comfort. Fast Passport Center renewed both simultaneously in 5 business days. We made the conference and brought back new ideas for the inn.",
      service: "Dual Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "ltt-1",
      name: "Littleton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "35 Cottage St",
      city: "Littleton",
      state: "NH",
      zip: "03561",
      phone: "(603) 444-3301",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Littleton — Downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Littleton and the central North Country. Located on Cottage Street near Main Street. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "ltt-2",
      name: "Grafton County Registry of Deeds",
      type: "County Passport Acceptance",
      address: "3785 Dartmouth College Hwy",
      city: "North Haverhill",
      state: "NH",
      zip: "03774",
      phone: "(603) 787-6941",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "North Haverhill — 25 miles southwest",
      website: "https://www.graftoncountynh.gov",
      websiteLabel: "Grafton County Government",
      notes: "County-level passport acceptance serving all Grafton County residents. More appointment availability than smaller post offices.",
      icon: "ri-government-line",
    },
    {
      id: "ltt-3",
      name: "Bethlehem Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2241 Main St",
      city: "Bethlehem",
      state: "NH",
      zip: "03574",
      phone: "(603) 869-5771",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "Bethlehem — 5 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Smaller facility serving Bethlehem area. Limited hours — call ahead for appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "ltt-4",
      name: "Lancaster Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 Main St",
      city: "Lancaster",
      state: "NH",
      zip: "03584",
      phone: "(603) 788-2762",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lancaster — 9 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Neighboring North Country facility serving Lancaster and surrounding towns. Good option if Littleton appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "ltt-5",
      name: "St. Johnsbury Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1153 Main St",
      city: "St. Johnsbury",
      state: "VT",
      zip: "05819",
      phone: "(802) 748-9692",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "St. Johnsbury, VT — 20 miles northwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Just across the Connecticut River in Vermont. Convenient for Littleton residents near the VT border — serves Vermont's Northeast Kingdom.",
      icon: "ri-mail-line",
    },
    {
      id: "ltt-6",
      name: "Berlin Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 Main St",
      city: "Berlin",
      state: "NH",
      zip: "03570",
      phone: "(603) 752-2480",
      hours: "Mon–Fri: 8:30 AM – 4:00 PM",
      distance: "Berlin — 30 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger North Country facility east of Littleton. Convenient for Littleton residents heading toward the Androscoggin Valley.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to Boston Agency", agency: "170 miles — 2 hour 45 minute drive via I-93 plus Boston traffic", fpc: "We drive for you — no appointment needed" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-snowy-line",
      title: "Underestimating Winter Travel Delays for Boston Agency Drive",
      description: "Littleton residents attempting a same-day Boston agency run in winter face the Franconia Notch stretch of I-93 — one of the most weather-exposed sections of highway in New England. Snow squalls, ice, and white-out conditions can turn a 2 hour 45 minute trip into 5+ hours. Registered courier service eliminates this dangerous winter drive entirely — and operates reliably year-round.",
    },
    {
      icon: "ri-compass-line",
      title: "Not Checking Six-Month Passport Validity Before Booking White Mountain Adventure Travel",
      description: "Littleton's outdoor recreation community regularly books international adventure travel — Patagonia trekking, New Zealand mountaineering, European Alps skiing. Many countries require 6 months validity beyond return date. Outfitters and guides who book trips 6+ months out often discover their passport expires within that window, jeopardizing the entire expedition.",
    },
    {
      icon: "ri-restart-line",
      title: "Using the Wrong Renewal Form — DS-82 vs DS-11 Confusion",
      description: "Many North Country residents with older passports assume they can renew by mail (DS-82). If your passport was issued more than 15 years ago, issued before age 16, or has a name change without documentation, you must apply in person using DS-11 at a Littleton-area acceptance facility. Filing by mail with the wrong form guarantees rejection and delays.",
    },
    {
      icon: "ri-image-line",
      title: "North Country Photo Shops Using Incorrect Passport Photo Specifications",
      description: "Some small-town photo services in the North Country use older equipment or are unfamiliar with current U.S. Department of State photo requirements. Photos must be exactly 2x2 inches, pure white background, neutral expression, no glasses, and high-resolution. Always verify photos meet current standards — even from local pharmacies.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Assuming the Closest Passport Agency Is in Burlington, VT or Portland, ME",
      description: "Littleton residents, situated near the Vermont border, sometimes assume Burlington VT or Portland ME has a passport agency. Neither does. The closest is Boston — 170 miles south. The only passport agencies in New England are in Boston, St. Albans VT, and Portsmouth NH (National Passport Center, not an agency). Understanding this geography prevents wasted travel.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Until Summer Tourist Season When Acceptance Facilities Are Booked",
      description: "The North Country's summer and fall foliage seasons bring thousands of visitors — and Littleton-area acceptance facilities book appointments 2–4 weeks out during peak months (June–October). If you need a DS-11 in-person application during peak season, expect long waits. Plan ahead or use Fast Passport Center's document pickup service to skip the acceptance facility entirely for eligible renewals.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS location in Littleton, Franconia, or St. Johnsbury." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the Boston Passport Agency — 170 miles south via I-93." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Boston Passport Agency via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Littleton or North Country address — fully trackable." },
  ],
  faqs: [
    {
      q: "How far is Littleton from the Boston passport agency?",
      a: "Littleton is approximately 170 miles from the Boston Passport Agency at the Tip O'Neill Federal Building on Causeway Street — about 2 hours 45 minutes south via I-93 through Franconia Notch, past Concord and Manchester, then into Boston. The Boston agency requires pre-scheduled NPIC appointments and does not accept walk-ins. Appointments typically take 2–3 weeks to secure.",
    },
    {
      q: "Is there a passport agency closer to Littleton than Boston?",
      a: "No. There is no passport agency anywhere in New Hampshire, Vermont, or Maine. The closest passport agency to Littleton is the Boston Passport Agency at the Tip O'Neill Federal Building — about 170 miles south. The National Passport Center is in Portsmouth, NH (about 150 miles southeast) but this is a processing center only, not a public agency.",
    },
    {
      q: "Can I get a passport in Littleton without driving to Boston?",
      a: "Yes — and this is the most practical option for most Littleton residents. Fast Passport Center's registered courier service handles everything from Littleton. You complete the application online, ship documents via overnight courier, and we hand-deliver to the Boston Passport Agency. Your new passport arrives via overnight delivery to your Littleton address — no Boston drive needed.",
    },
    {
      q: "Does winter weather affect courier service from Littleton?",
      a: "Winter weather in the North Country can be severe, but I-93 from Littleton through Franconia Notch is maintained as a priority state route year-round. Overnight courier services operate reliably even during winter. Fast Passport Center monitors weather conditions and adjusts routing if needed. For winter travel, we recommend starting the passport process at least 4 weeks before departure.",
    },
    {
      q: "Where can I get passport photos in Littleton?",
      a: "Rite Aid at 545 Meadow St in Littleton offers passport photo services. For additional options, Walgreens in St. Johnsbury, VT (24 Railroad St) and Walmart in Woodsville (11 Church St) also provide passport photos. Verify photos meet current 2x2 inch specifications with white background before submitting.",
    },
    {
      q: "How fast can I get an emergency passport in Littleton?",
      a: "Emergency processing for Littleton residents is typically 24–48 hours via courier to Boston. The North Country's position along the I-93 corridor ensures reliable overnight routing to Boston year-round. Standard expedited processing runs 2–9 business days.",
    },
    {
      q: "Does the Littleton Post Office accept passport applications?",
      a: "Yes. The Littleton Post Office at 35 Cottage St is a passport acceptance facility. They accept DS-11 applications and verify identity documents. Call (603) 444-3301 for an appointment. Hours are limited — 9 AM to 4 PM, Monday through Friday only.",
    },
    {
      q: "I'm a White Mountain guide — how early should I start passport prep for international expeditions?",
      a: "White Mountain guides and outdoor professionals should start passport preparation at least 3–4 months before any international expedition or guiding season. Expeditions to remote locations often require visas (which need a valid passport first), and the combined passport-plus-visa timeline can run 8–12 weeks. Fast Passport Center's 2–9 business day courier service handles the passport portion quickly.",
    },
    {
      q: "Can Fast Passport Center help Bethlehem and Franconia residents too?",
      a: "Absolutely. We serve the entire North Country including Littleton, Bethlehem (5 miles east), Franconia (7 miles south), Sugar Hill, Whitefield, Lisbon, Twin Mountain, and the surrounding White Mountains communities. Document pickup is available throughout northern Grafton County.",
    },
    {
      q: "The Littleton Post Office is booked for weeks — what are my alternatives?",
      a: "If Littleton appointments are full, check the Bethlehem Post Office (2241 Main St, 5 miles east), the Lancaster Post Office (120 Main St, 9 miles north), or the Grafton County Registry in North Haverhill (25 miles southwest). For eligible DS-82 mail-in renewals, you can skip the acceptance facility entirely and use Fast Passport Center's courier service.",
    },
    {
      q: "I'm flying from BOS — can I pick up my passport at the Boston agency same-day?",
      a: "Only if you have secured a NPIC appointment at the Boston Passport Agency, which requires calling the National Passport Information Center and demonstrating life-or-death emergency travel within 72 hours. Appointments are extremely limited and not guaranteed. For everyone else, courier service is the fastest and most reliable option.",
    },
    {
      q: "What's the closest airport to Littleton for international flights?",
      a: "Littleton travelers typically fly from Manchester-Boston Regional Airport (MHT, about 100 miles south), Boston Logan International Airport (BOS, about 170 miles south), or Burlington International Airport (BTV, about 90 miles west in Vermont). BOS offers the most international direct routes; MHT and BTV serve mainly domestic connections.",
    },
  ],
  photoLocations: [
    { name: "Rite Aid — Littleton", address: "545 Meadow St, Littleton, NH 03561", hours: "Mon–Sun: 8AM–9PM" },
    { name: "Walgreens — St. Johnsbury VT", address: "24 Railroad St, St. Johnsbury, VT 05819", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Walmart Photo — Woodsville", address: "11 Church St, Woodsville, NH 03785", hours: "Mon–Sun: 7AM–9PM" },
    { name: "CVS Pharmacy — Lincoln", address: "64 Main St, Lincoln, NH 03251", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Plymouth", address: "24 Main St, Plymouth, NH 03264", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–2PM" },
    { name: "FedEx Office — Concord", address: "67 Fort Eddy Rd, Concord, NH 03301", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM" },
  ],
  dmvLocations: [
    { name: "NH DMV — Twin Mountain", address: "549 Route 302, Twin Mountain, NH 03595", hours: "Mon–Fri: 8:00AM–4:30PM", note: "Closest DMV to Littleton. REAL ID, driver's license, and state ID services for North Country residents.", featured: true },
    { name: "NH DMV — Concord", address: "23 Hazen Dr, Concord, NH 03301", hours: "Mon–Fri: 8:00AM–4:30PM", note: "State headquarters DMV with full services. About 100 miles south of Littleton.", featured: false },
    { name: "NH DMV — Plymouth", address: "271 Main St, Plymouth, NH 03264", hours: "Mon–Fri: 8:00AM–4:30PM", note: "Mid-way DMV option about 50 miles south of Littleton in the Plymouth area.", featured: false },
  ],
  airports: [
    {
      code: "BTV",
      name: "Burlington International Airport",
      distance: "90 miles west of Littleton",
      address: "1200 Airport Dr, South Burlington, VT 05403",
      note: "Closest commercial airport to Littleton with domestic routes. About 1 hour 45 minutes via I-93 and I-89. Convenient for North Country and Northeast Kingdom travelers.",
      flightUrl: "https://www.btv.aero/",
      flightLabel: "BTV Airport",
      featured: true,
    },
    {
      code: "MHT",
      name: "Manchester-Boston Regional Airport",
      distance: "100 miles south of Littleton",
      address: "1 Airport Rd, Manchester, NH 03103",
      note: "New Hampshire's largest airport with domestic routes. About 2 hours via I-93 south. More route options than BTV.",
      flightUrl: "https://www.flymanchester.com/",
      flightLabel: "MHT Airport",
      featured: false,
    },
    {
      code: "BOS",
      name: "Boston Logan International Airport",
      distance: "170 miles south of Littleton",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "New England's largest international gateway with direct flights worldwide. About 2 hours 45 minutes via I-93. Co-located with Boston Passport Agency.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "BOS Airport",
      featured: false,
    },
    {
      code: "PWM",
      name: "Portland International Jetport",
      distance: "110 miles southeast of Littleton",
      address: "1001 Westbrook St, Portland, ME 04102",
      note: "Maine's busiest airport with domestic routes. About 2 hours 15 minutes via NH-116 and US-302. Alternative for eastern North Country travelers.",
      flightUrl: "https://portlandjetport.org/",
      flightLabel: "PWM Airport",
      featured: false,
    },
  ],
};